// components/blog/BlogNavbar.tsx
"use client";

import { useState } from "react";
import Link from "next/link";
import { Container, Nav, Navbar, Offcanvas } from "react-bootstrap";
import type { Category } from "@/data/mockData";
import styles from "@/app/mag/blog.module.css";

export default function BlogNavbar({ categories = [] }: { categories?: Category[] }) {
  const links = [
    { title: "دسته‌بندی‌ها", href: "/mag/search" },
    ...categories.slice(0, 4).map((category) => ({
      title: category.title,
      href: `/mag/search?category[]=${encodeURIComponent(category.id)}`,
    })),
    { title: "هتل‌ها", href: "/hotels" },
  ];
  const [showSearch, setShowSearch] = useState(false);
  const [query, setQuery] = useState("");

  const handleSearchSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (query.trim().length > 0) {
      window.location.href = `/mag/search?search=${encodeURIComponent(query.trim())}`;
    }
  };

  return (
    <header className={`sticky-top ${styles.navbarWrapper}`}>
      <Container>
        <Navbar expand="lg" className={styles.blogNavbar}>
          <Navbar.Brand as={Link} href="/mag" className={styles.brand}>
            <span className={styles.brandMark}>ی</span>
            <span className={styles.brandText}>
              <span className={styles.brandName}>ایرانیجا</span>
              <span className={styles.brandTagline}>مجله گردشگری</span>
            </span>
          </Navbar.Brand>

          <Navbar.Offcanvas id="blog-navbar-offcanvas" placement="end" className={styles.navOffcanvas}>
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>ایرانیجا</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Nav className={styles.navLinks}>
                {links.map((link) => (
                  <Nav.Link key={link.href} as={Link} href={link.href} className={styles.navLink}>
                    {link.title}
                  </Nav.Link>
                ))}
              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>

          <form className={`d-none d-lg-block ${styles.searchForm}`} role="search" onSubmit={handleSearchSubmit}>
            <input
              type="search"
              className={styles.searchInput}
              placeholder="جستجوی مقاله..."
              aria-label="جستجوی مقاله"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
            <button type="submit" className={styles.searchSubmit} aria-label="جستجو">
              <i className="bi bi-search" aria-hidden="true" />
            </button>
          </form>

          <div className={styles.navActions}>
            <button
              type="button"
              className={`d-lg-none ${styles.iconBtn}`}
              onClick={() => setShowSearch(true)}
              aria-label="جستجو"
            >
              <i className="bi bi-search" aria-hidden="true" />
            </button>
            <Link href="/hotels" className={styles.ctaBtn} aria-label="رزرو هتل">
              {/* <i className="bi bi-building" aria-hidden="true" /> */}
              <span className={styles.ctaLabel}>رزرو هتل</span>
            </Link>
            <Navbar.Toggle aria-controls="blog-navbar-offcanvas" className={styles.navToggle} />
          </div>
        </Navbar>
      </Container>

      <Offcanvas show={showSearch} onHide={() => setShowSearch(false)} placement="top" className={styles.searchOffcanvas}>
        <Offcanvas.Body>
          <form className={styles.searchFormMobile} role="search" onSubmit={handleSearchSubmit}>
            <div className={styles.searchField}>
              <i className={`bi bi-search ${styles.searchFieldIcon}`} aria-hidden="true" />
              <input
                autoFocus
                type="search"
                className={styles.searchInput}
                placeholder="جستجوی مقاله..."
                aria-label="جستجوی مقاله"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
              />
            </div>
            <button type="submit" className={styles.searchSubmitLabeled}>
              جستجو
            </button>
          </form>
        </Offcanvas.Body>
      </Offcanvas>
    </header>
  );
}
